<template>
  <el-container>
    <el-header height="auto">
      <el-card>高级加密标准（英语：Advanced Encryption Standard，缩写：AES），在密码学中又称Rijndael加密法，是美国联邦政府采用的一种区块加密标准。这个标准用来替代原先的DES，已经被多方分析且广为全世界所使用。经过五年的甄选流程，高级加密标准由美国国家标准与技术研究院（NIST）于2001年11月26日发布于FIPS PUB 197，并在2002年5月26日成为有效的标准。2006年，高级加密标准已然成为对称密钥加密中最流行的算法之一。</el-card>
    </el-header>
    <el-main>
      <el-form
        size="small"
        :inline="true"
        :model="form"
        :rules="rules"
        ref="form"
        :label-position="labelPosition"
        :label-width="labelWidth"
        @submit.native.prevent
      >
        <el-form-item label="加密模式">
          <el-select v-model="mode.value" placeholder="请选择">
            <el-option
              v-for="option in mode.options"
              :key="option.id"
              :label="option"
              :value="option"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="填充模式">
          <el-select v-model="padding.value" placeholder="请选择">
            <el-option
              v-for="option in padding.options"
              :key="option.id"
              :label="option"
              :value="option"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="密钥长度">
          <el-select v-model="keysize.value" placeholder="请选择">
            <el-option
              v-for="option in keysize.options"
              :key="option.id"
              :label="option"
              :value="option"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="密文格式">
          <el-select v-model="format.value" placeholder="请选择">
            <el-option
              v-for="option in format.options"
              :key="option.id"
              :label="option"
              :value="option"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="密钥" prop="key">
          <el-input v-model="form.key"></el-input>
        </el-form-item>
        <el-form-item label="初向量" prop="iv">
          <el-input v-model="form.iv"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm(encrypt)">加密</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm(decrypt)">解密</el-button>
        </el-form-item>
        <el-form-item>
          <el-upload action="" multiple :on-change="handleChange" :on-remove="handleChange" :limit="1" :auto-upload="false">
            <el-button type="primary">上传文件</el-button>
          </el-upload>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-input
              type="textarea"
              :autosize="autosize"
              :disabled="form.disable_input"
              v-model="form.input"
              placeholder="请输入待加解密内容，或直接上传文件"
            ></el-input>
          </el-col>
          <el-col :span="12">
            <el-input
              type="textarea"
              :autosize="autosize"
              v-model="form.output"
              placeholder=""
            ></el-input>
          </el-col>
        </el-row>
      </el-form>
    </el-main>
  </el-container>
</template>


<script>
import { api } from "@/utils.js";

export default {
  name: "AES",
  data() {
    var validateKey = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入密钥"));
      }
      if (value.length !== this.keysize.value / 8) {
        return callback(
          new Error(`密钥长度必须为${this.keysize.value / 8}字节`)
        );
      }
      return callback();
    };

    var validateIV = (rule, value, callback) => {
      if (this.mode.value !== "ECB") {
        if (!value) {
          return callback(new Error("请输入初向量"));
        }
        if (value.length !== 16) {
          return callback(new Error(`初向量长度必须为16字节`));
        }
      }
      return callback();
    };
    return {
      mode: {
        value: "CBC",
        options: ["CBC", "CFB", "CTR", "OFB", "ECB"]
      }, // 加密模式
      padding: {
        value: "Pkcs7",
        options: [
          "Pkcs7",
          "Iso97971",
          "AnsiX923",
          "Iso10126",
          "ZeroPadding",
          "NoPadding"
        ]
      }, // 填充模式
      keysize: {
        value: 128,
        options: [128, 192, 256]
      }, // 密钥长度
      format: {
        value: "base64",
        options: ["base64", "hex"]
      }, // 密文格式
      form: this.initform,
      rules: {
        key: [{ validator: validateKey, trigger: "blur" }],
        iv: [{ validator: validateIV, trigger: "blur" }]
      }
    };
  },
  props: {
    labelPosition: { type: String, default: "left" },
    labelWidth: { type: String, default: "auto" },
    autosize: {
      type: Object,
      default: function() {
        return { minRows: 20, maxRows: 35 };
      }
    },
    initform: {
      type: Object,
      default: function() {
        return {
          input: "",
          disable_input: false,
          output: "",
          key: "abcdefghijklmnop",
          iv: "abcdefghijklmnop",
          file: null
        };
      }
    }
  },
  methods: {
    submitForm: function(callback) {
      this.$refs["form"].validate(valid => {
        if (!valid) {
          return false;
        }
        return callback();
      });
    },
    encrypt: function() {
      let config = { headers: { "Content-Type": "multipart/form-data" } };
      let data = new FormData();
      data.append("key", this.form.key);
      data.append("iv", this.form.iv);
      data.append("mode", this.mode.value);
      data.append("padding", this.padding.value);
      data.append("plaintext", this.form.input);
      data.append("format", this.format.value);
      if (this.form.file) {
        data.append("file", this.form.file);
      }
      api
        .post("/crypto/aes/encrypt", data, config)
        .then(response => {
          if (response.data.error) {
            this.form.output = response.data.error;
          } else {
            this.form.output = response.data.ret;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    decrypt: function() {
      let config = { headers: { "Content-Type": "multipart/form-data" } };
      let data = new FormData();
      data.append("key", this.form.key);
      data.append("iv", this.form.iv);
      data.append("mode", this.mode.value);
      data.append("padding", this.padding.value);
      data.append("ciphertext", this.form.input);
      data.append("format", this.format.value);
      if (this.form.file) {
        data.append("file", this.form.file);
      }
      api
        .post("/crypto/aes/decrypt", data, config)
        .then(response => {
          if (response.data.error) {
            this.form.output = response.data.error;
          } else {
            this.form.output = response.data.ret;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    handleChange: function(file, fileList) {
      if (fileList.length > 0) {
        this.form.file = fileList[0].raw;
        this.form.input = "已上传文件：" + fileList[0].name;
        this.form.disable_input = true;
      } else {
        this.form.file = null;
        this.form.input = "";
        this.form.disable_input = false;
      }
    }
  }
};
</script>
<style scoped>
</style>
